export default __webpack_public_path__ + "maps-examples-simple-map-view-thumbnail-480-5fe8b3c7a1625da1df6ee3a5ea0635de.webp";